<template>
    <div class="reservaciones-section">
        <div class="reservaciones-content">
            <h2 class="reservaciones-title fuente-posm">
                Reservaciones sin Complicaciones
            </h2>
            <p class="reservaciones-text fuente-nova">
                Permite a tus clientes conocer tu disponibilidad y reservar por WhatsApp en segundos.
                Tu administras tus espacios disponibles en nuestra tablet de administración de turnos
                y recibes notificaciones cuando un cliente ha reservado.
            </p>
        </div>
        <div class="reservaciones-image">
            <img :src="a66" alt="Reservaciones">
        </div>
    </div>
</template>

<script>
export default {
    name: 'ReservacionesNew',
    data() {
        return {
            a66: require('@/assets/images/a66.webp')
        }
    }
}
</script>

<style lang="css" scoped>
.reservaciones-section {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 40px 60px;
    box-sizing: border-box;
    scroll-snap-align: start;
    gap: 40px;
}

.reservaciones-image {
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    order: 1;
}

.reservaciones-image img {
    width: 280px;
    height: auto;
}

.reservaciones-content {
    flex: 1;
    max-width: 700px;
    order: 2;
}

.reservaciones-title {
    color: var(--color-2);
    font-size: 68px;
    line-height: 1.1;
    margin: 0 0 20px 0;
}

.reservaciones-text {
    color: var(--color-3);
    font-size: 29px;
    line-height: 1.3;
    margin: 0;
    padding-left: 10px;
}

/* Tablet */
@media (max-width: 992px) and (min-width: 769px) {
    .reservaciones-title {
        font-size: 60px;
    }

    .reservaciones-text {
        font-size: 27px;
    }

    .reservaciones-image img {
        width: 220px;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .reservaciones-section {
        flex-direction: column;
        justify-content: flex-start;
        height: 100vh;
        padding: 100px 20px 40px 20px;
        gap: 20px;
    }

    .reservaciones-content {
        order: 1;
        max-width: 100%;
        flex: none;
    }

    .reservaciones-image {
        order: 2;
        width: 100%;
        flex: 1;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        padding-top: 20px;
    }

    .reservaciones-image img {
        width: 60%;
        max-width: 240px;
    }

    .reservaciones-title {
        font-size: 24px;
        line-height: 1.2;
        margin: 0 0 10px 0;
    }

    .reservaciones-text {
        font-size: 16px;
        padding-left: 10px;
        margin: 0;
    }
}
</style>
